export default function cartDataMapping(payload) {

    const mapBillingAddress = (billingAddress) => {
        return {
            "firstName": billingAddress.firstName || "",
            "lastName": billingAddress.lastName || "",
            "emailAddress": billingAddress.emailAddress || "",
            "phoneNumber": billingAddress.phoneNumber || "",
            "mobilePhoneNumber": billingAddress.mobilePhoneNumber || "",
            "line1": billingAddress.line1 || "",
            "line2": billingAddress.line2 || "",
            "postalCode": billingAddress.postalCode || "",
            "city": billingAddress.city || "",
            "state": billingAddress.state || "",
            "attention": billingAddress.attention || "",
            "companyName": billingAddress.companyName || "",
            "country": {
                "name": billingAddress.country ? billingAddress.country.name || "" : "",
                "countryId": billingAddress.country ? billingAddress.country.countryId : 0
            }
        }
    }

    const mapShippingAddress = (shippingAddress) => {
        return {
            "firstName": shippingAddress.firstName || "",
            "lastName": shippingAddress.lastName || "",
            "emailAddress": shippingAddress.emailAddress || "",
            "phoneNumber": shippingAddress.phoneNumber || "",
            "mobilePhoneNumber": shippingAddress.mobilePhoneNumber || "",
            "line1": shippingAddress.line1 || "",
            "line2": shippingAddress.line2 || "",
            "postalCode": shippingAddress.postalCode || "",
            "city": shippingAddress.city || "",
            "state": shippingAddress.state || "",
            "attention": shippingAddress.attention || "",
            "companyName": shippingAddress.companyName || "",
            "country": {
                "name": shippingAddress.country ? shippingAddress.country.name || "" : "",
                "countryId": shippingAddress.country ? shippingAddress.country.countryId : "" || ""
            }
        }
    }

    const mapOrderLines = (orderLines) => {
        return orderLines.map(orderLine => {
            return {
                "inStock": 42,
                "brand": orderLine.brand,
                "reasonCode": orderLine.reasonCode ||  "",
                "productLabel": orderLine.brand || "",
                "image": orderLine.image || "",
                "total": orderLine.total || "",
                "quantity": orderLine.quantity,
                "orderLineId": orderLine.orderLineId,
                "productSku": orderLine.productSku || "",
                "variantSku": orderLine.variantSku || "",
                "productName": orderLine.productName || "",
                "unitPrice": orderLine.unitPrice,
                "tax": orderLine.tax,
                "totalWithDiscount": orderLine.totalWithDiscount || "",
                "discount": orderLine.discount,
                "colliSize": orderLine.colliSize,
                "colliSizeFormatted": orderLine.colliSizeFormatted,
                "inStock": orderLine.inStock,
                "inStockFormatted": orderLine.inStockFormatted,
                "unitPriceAmount": orderLine.unitPriceAmount
            }
        })
    }

    const mappedCart = {
        "billingAddress": mapBillingAddress(payload.billingAddress) || {},
        "shippingAddress": mapShippingAddress(payload.shippingAddress) || {},
        "orderLines": mapOrderLines(payload.orderLines) || [],
        "orderTotal": payload.orderTotal || "",
        "subTotal": payload.subTotal || "",
        "taxTotal": payload.taxTotal || "",
        "discountTotal": payload.discountTotal || "",
        "shippingTotal": payload.shippingTotal || "",
        "paymentTotal": payload.paymentTotal || "",
        "removeOrderlineId": payload.removeOrderlineId,
        "itemsCount": payload.itemsCount,
        "tax": payload.tax || "",
        "currency": payload.currency || "",
        "subTotalAmount": payload.subTotalAmount,
        "orderTotalAmount": payload.orderTotalAmount,
        "taxAmount": payload.taxTotalAmount,
        "shippingTotalAmount": payload.shippingTotalAmount,
    }

    return mappedCart
}